// Notes: ~/comments/aos-threejs-poc/liveBodyRig_two_rigs_can_be_the_body.md

// One per render path, and only one is ever mounted; next publishes its own name.
const SPLAT_ROOTS = ['__OGS_AVATAR_ROOT__', '__OGS_AVATAR_ROOT_NEXT__']

const placed = (group) => (group?.position && group?.rotation ? group : null)

/** The mounted splat character's root, whichever render path published it. */
export function resolveSplatAvatarRoot(scope = typeof window !== 'undefined' ? window : globalThis) {
  for (const name of SPLAT_ROOTS) {
    const root = placed(scope?.[name])
    if (root) return root
  }
  return null
}

/** The mounted avatar's transform group, or null. The GLB rig wins when both exist. */
export function resolveAvatarTransformTarget(scope = typeof window !== 'undefined' ? window : globalThis) {
  return placed(scope?.__AVATAR_GROUP__) ?? resolveSplatAvatarRoot(scope)
}
